import * as http from 'utils/http';

const meRequest = () => ({
  type: 'ME_REQUEST',
});

const meDone = (user) => ({
  ...user,
  type: 'ME_DONE',
});

const meCancel = (error) => ({
  type: 'ME_CANCEL',
  error,
});

export const fetchMe = () => {
  return (dispatch, getState, config) => {
    dispatch(meRequest());
    return http
      .get(config.API_URL + 'users/me/')
      .catch((err) => {
        dispatch(meCancel(err));
        throw err;
      })
      .then((user) => {
        dispatch(meDone(user));
        return user;
      });
  };
};

export function openSnackbar(message, duration = 5000, action = null) {
  return (dispatch) => {
    dispatch({
      type: 'OPEN_SNACKBAR',
      message,
      duration,
      action,
    });
  };
}

export function closeSnackbar() {
  return (dispatch) => {
    dispatch({
      type: 'CLOSE_SNACKBAR',
    });
  };
}
